import { Component, HostListener, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { SharedServices } from '../../../../services/shared.services'
import { AuthService } from '../../../../services/auth.services'
import { ModalService } from '../../../../services/modal.service'
import { RestServices } from '../../../../services/rest.services'
import { notification } from 'onsenui'
import { tokenDeviceUrl } from '../../../../../helper/common'
import { SocketService } from '../../../../services'

@Component({
    selector: 'app-modal-device-info',
    templateUrl: './device-info.component.html',
    styleUrls: ['../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/main-view.component.css',
        '../../../../stagingcss/lui-select.component.css',
        './device-info.component.css'],
})
export class ModalDeviceInfoComponent implements OnInit {
    ModalDeviceInfo = 'hidden'
    ModalDeviceQR = 'hidden'
    createTime
    updateTime
    userAgent
    deviceId
    deviceNote
    checkAction = false
    idClient
    clientIdParam
    urlDevice
    checkLang = true
    titleEn = 'Please install OrthoComm App and read this QR code with the app'
    titleJa = 'OrthoCommアプリをインストールし、アプリで以下のQRコードを読み込んでください'
    statusEsc
    en = {}
    showEN = true
    innerHeight: number

    constructor(private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private _sharedService: SharedServices,
                private socketService: SocketService,
                private modalService: ModalService) {
        this.modalService.changeEmitted$.subscribe(
            success => {
                this.checkAction = false
                if (success[0] === 'activeModalDeviceInfo') {
                    this.ModalDeviceInfo = 'active'
                    this.statusEsc = true
                    if (success[1]) {
                        this.deviceId = success[1]._id
                        this.createTime = success[1].createTime
                        this.updateTime = success[1].updateTime
                        this.userAgent = success[1].userAgent
                        this.deviceNote = success[1].note
                        this.idClient = success[1].clientId
                        this.clientIdParam = '{"clientId":"' + [this.idClient] + '"}'
                    }
                }
                if (success[0] === 'activeModalDeviceQR') {
                    this.ModalDeviceQR = 'active'
                    this.statusEsc = true
                    this.deviceId = success[1]._id
                    this.createTime = success[1].createTime
                    this.updateTime = success[1].updateTime
                    this.userAgent = success[1].userAgent
                    this.deviceNote = success[1].note
                    this.idClient = success[1].clientId
                    this.urlDevice = tokenDeviceUrl + success[2] + '/' + success[1].activationToken
                    this.clientIdParam = '{"clientId":"' + [this.idClient] + '"}'
                    if (localStorage.lang === 'true') {
                        this.checkLang = true
                    } else {
                        this.checkLang = false
                    }
                }
            })
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        if (this.statusEsc) {
            if (keyPressed === 27) {
                event.preventDefault()
                this.changeLanguage()
                if (this.ModalDeviceInfo === 'active') {
                    notification.confirm({
                        message: this.en['alert-content-discard'],
                        title: '<b>' + this.en['alert-discard'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], 'OK'],
                        callback: i => {
                            if (i === 1) {
                                this.hidenModal()
                            }
                        },
                    })
                } else if (this.ModalDeviceQR === 'active') {
                    this.hidenModalQR()
                }
            }
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerHeight = window.innerHeight
    }

    ngOnInit() {
        this.innerHeight = window.innerHeight
    }

    getCanvasHeight() {
        if (this.innerHeight < 600) {
            return 400
        } else if (this.innerHeight < 800) {
            return 500
        }
        return 600

    }

    hidenModal() {
        this.ModalDeviceInfo = 'hidden'
        this.statusEsc = false
    }

    hidenModalQR() {
        this.ModalDeviceQR = 'hidden'
        this.statusEsc = false
    }

    changeNote() {
        this.checkAction = true
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    saveButton() {
        if (this.checkAction) {
            if (localStorage.lang === 'true') {
                notification.confirm(
                    {
                        message: 'Are you sure to save this item?',
                        title: '<b>Save</b>',
                        buttonLabels: ['Cancel', 'OK'],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i === 1) {
                                this.ModalDeviceInfo = 'hidden'
                                this.updateDevice()
                            }
                        },
                    })
            } else {
                notification.confirm(
                    {
                        message: 'このアイテムを保存しますか？',
                        title: '<b>保存</b>',
                        buttonLabels: ['戻る', 'OK'],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i === 1) {
                                this.ModalDeviceInfo = 'hidden'
                                this.updateDevice()
                            }
                        },
                    })
            }
        } else {
            this.ModalDeviceInfo = 'hidden'
        }
    }

    removeButton() {
        if (localStorage.lang === 'true') {
            notification.confirm(
                {
                    message: 'Are you sure to remove this item?',
                    title: '<b>Save</b>',
                    buttonLabels: ['Cancel', 'OK'],
                    modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {
                            this.ModalDeviceInfo = 'hidden'
                            this.removeDevice()
                        }
                    },
                })
        } else {
            notification.confirm(
                {
                    message: '本当にこのアイテムを削除しますか?',
                    title: '<b>削除</b>',
                    buttonLabels: ['戻る', 'OK'],
                    modifier: 'rowfooter',
                    callback: i => {
                        if (i === 1) {
                            this.ModalDeviceInfo = 'hidden'
                            this.removeDevice()
                        }
                    },
                })
        }
    }

    updateDevice() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [
                {
                    collection: 'clientDevice',
                    id: this.deviceId,
                    type: 'update',
                    value: {
                        note: this.deviceNote,
                    },
                },
            ],
            status: {
                client: {
                    map: { [this.idClient]: true },
                    paths: { '{}': true },
                },
                clientDevice: {
                    paths: { [this.clientIdParam]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    if (success['status'] === 'OK') {
                        this._sharedService.emitChangeParent(success['response']['clientDevice']['paths'][this.clientIdParam])
                        // this.router.navigate(['/app/main/client/search']);
                    }
                },
            )
        })
    }

    removeDevice() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [
                {
                    collection: 'clientDevice',
                    id: this.deviceId,
                    type: 'remove',
                },
            ],
            status: {
                client: {
                    map: { [this.idClient]: true },
                    paths: { '{}': true },
                },
                clientDevice: {
                    paths: { [this.clientIdParam]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    if (success['status'] === 'OK') {
                        this._sharedService.emitChangeParent(success['response']['clientDevice']['paths'][this.clientIdParam])
                        // this.router.navigate(['/app/main/client/search']);
                        //
                        const payload = {
                            clientId: this.idClient,
                            clientDeviceId: this.deviceId,
                            deviceRemoved: true
                        }
                        this.socketService.emitWebSocketEvent('device_notice', {
                            clinic: this.authData.getUser(),
                            client: payload,
                            clientDeviceId: this.deviceId
                        })
                        console.debug('delete-device-token')
                        this.restApi.http_post('websocket/delete-device-token', payload, tokenReNew).subscribe( success => {
                                    let resourceData = {
                                        line_code: "client-app/setting/device-info.component.ts line 324",
                                        reason: "Delete device token",     
                                        token: this.authData.getItem('token'),           
                                        date: Date.now()
                                    }

                                    console.debug('remove deviceTocken')
                                    this.restApi.http_post('account/clientLog', resourceData, tokenReNew).subscribe(res => {
                                    })
                            },
                        )

                    }
                },
            )
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/device-info/device-info.component.ts